export default async function moveNode({ state, props, graphql }) {
  const node = props.node
  const parentId = props.parentId || null
  const nearestTopLeaf = props.nearestTopLeaf ? props.nearestTopLeaf.id : null

  const fragment = parentId ? `parent: "${parentId}", ` : ''

  await graphql.mutate(`{
    moveNode(id: "${node.id}", ${fragment} nearestTopLeaf: "${nearestTopLeaf}") {
      id
    }
  }`)
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/moveNode.js